import I18n from 'I18n';
import { SET_SESSION_DATE } from '../actions/ActionTypes';
// Note: we cannot consume I18n at module evaluation time
// So first set these values to null, then overwrite them when the locale is loaded
const initialState = {
  currentDate: null,
  currentDateInPortalTz: null
};

// Storing current date in Redux ensures components remain pure
const datesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SESSION_DATE:
      return Object.assign({}, state, {
        currentDate: new Date(),
        currentDateInPortalTz: I18n.moment.portalTz().format('YYYY-MM-DD')
      });
    default:
      return state;
  }
};
export default datesReducer;